export default "__VITE_ASSET__ZFYjvVLd__"